import { render, staticRenderFns } from "./drawer-change-list.vue?vue&type=template&id=6fe20fec&scoped=true"
import script from "./drawer-change-list.vue?vue&type=script&lang=js"
export * from "./drawer-change-list.vue?vue&type=script&lang=js"
import style0 from "./drawer-change-list.vue?vue&type=style&index=0&id=6fe20fec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe20fec",
  null
  
)

export default component.exports